import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { StyledArrowDownIcon, StyledDropdownItem, StyledIconButton, StyledLink } from './DropdownItem.styled'
import { IconTypeEnum } from '../../theme/icons'
import pxToRem from '../../utils/pxToRem'
import colors from '../../theme/colors'

const DropdownItem = (props) => {
  const {
    columnId,
    hasSubItems,
    itemId,
    setSelectedColumn,
    selectedColumn,
    selectedItem,
    setSelectedItem,
    slug,
    title,
  } = props
  const isBrowser = typeof window !== 'undefined'

  const [alreadySelected, setAlreadySelected] = useState(false)

  useEffect(() => {
    if (isBrowser) {
      const currentLocation = window.location.pathname
      if (currentLocation === `/${slug}`) setAlreadySelected(true)
    }
  }, [])

  const handleChangeSelectedSubItems = () => {
    setSelectedItem(itemId === selectedItem ? null : itemId)
    setSelectedColumn(
      itemId === selectedItem && columnId === selectedColumn ? null : columnId
    )
  }

  const isSelected = itemId === selectedItem && columnId === selectedColumn

  return (
    <StyledDropdownItem
      $hasSubItems={hasSubItems}
      $isSelected={isSelected || alreadySelected}
    >
      <StyledLink to={`/${slug}`}>{title}</StyledLink>
      {hasSubItems && (
        <StyledIconButton
          color={colors.unique.white}
          onClick={handleChangeSelectedSubItems}
          height={pxToRem(7)}
          type={IconTypeEnum.arrowDownNav}
          width={pxToRem(12)}
        >
          <StyledArrowDownIcon $isSelected={isSelected} />
        </StyledIconButton>
      )}
    </StyledDropdownItem>
  )
}

DropdownItem.propTypes = {
  columnId: PropTypes.number,
  hasSubItems: PropTypes.array,
  itemId: PropTypes.number,
  setSelectedColumn: PropTypes.func,
  selectedColumn: PropTypes.number,
  setSelectedItem: PropTypes.func,
  selectedItem: PropTypes.number,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default DropdownItem
